export type DEFAULT_EXTRACTED_PACKING_LIST_FORM_VALUES_TYPE = {
  // First section
  organizational: {
    location: string;
  };
  invited_modes: Record<string, boolean>;
  service: {
    incoterms: string;
  };

  // Address section
  pickup_address_name: string;
  pickup_country: string;
  pickup_state: string;
  pickup_city: string;
  pickup_street: string;
  pickup_zipcode: string;

  stop1_address_name: string;
  stop1_country: string;
  stop1_state: string;
  stop1_city: string;
  stop1_street: string;
  stop1_zipcode: string;

  // Packing list section
  packing_list: PackingListType[];
};

type PackingListType = {
  additional_information: string;

  stackable: boolean;
  hazardous: boolean;

  crating_required: boolean;
  crating_required_by: string;

  handling_required: boolean;
  handling_unit: string;

  is_dangerous_good: boolean;
  dangerous_good_value: string;
  un_number: string;

  temperature_control_required: boolean;
  temperature_control_value: string;

  length: string;
  width: string;
  height: string;
  units: string;
  weight_piece: string;
  w_unit: string;
  m_unit: string;

  good_customs_information: GoodCustomsInformationType[];
};

type GoodCustomsInformationType = {
  currency_code: string;
  description: string;
  hs_code: string;
  value: number;
};

export const DEFAULT_EXTRACTED_PACKING_LIST_FORM_VALUES: DEFAULT_EXTRACTED_PACKING_LIST_FORM_VALUES_TYPE = {
  organizational: {
    location: "",
  },
  invited_modes: {},
  service: {
    incoterms: "None",
  },

  pickup_address_name: "",
  pickup_country: "",
  pickup_state: "",
  pickup_city: "",
  pickup_street: "",
  pickup_zipcode: "",

  stop1_address_name: "",
  stop1_country: "",
  stop1_state: "",
  stop1_city: "",
  stop1_street: "",
  stop1_zipcode: "",

  packing_list: [
    {
      additional_information: "",

      handling_required: false,
      handling_unit: "",

      length: "",
      width: "",
      height: "",
      units: "",
      weight_piece: "",
      w_unit: "",
      m_unit: "",

      stackable: false,
      hazardous: false,

      temperature_control_required: false,
      temperature_control_value: "",

      is_dangerous_good: false,
      dangerous_good_value: "",
      un_number: "",

      crating_required: false,
      crating_required_by: "",

      good_customs_information: [
        {
          currency_code: "USD",
          description: "",
          hs_code: "",
          value: 0,
        },
      ],
    },
  ],
};
